import { HTMLProps } from 'react';
import clsx from 'clsx';

type DataRowProps = { align?: 'top' | 'middle' | 'bottom' } & Omit<
  HTMLProps<HTMLTableRowElement>,
  'className'
>;

export const TableRow = ({
  children,
  align = 'top',
  ...rest
}: DataRowProps) => {
  return (
    <tr
      {...rest}
      className={clsx(
        'group/table-row',
        align === 'top' && 'align-top',
        align === 'middle' && 'align-middle',
        align === 'bottom' && 'align-bottom',
        rest.onClick && 'cursor-pointer hover:bg-gray-50',
      )}
    >
      {children}
    </tr>
  );
};
